import(/* webpackMode: "eager" */ "/home/forge/leaderboard.greenball-events.ch/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/forge/leaderboard.greenball-events.ch/src/i18n/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InitProvider"] */ "/home/forge/leaderboard.greenball-events.ch/src/providers/init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/forge/leaderboard.greenball-events.ch/src/providers/query.tsx");
